import router from './../router';
import { createStore } from 'vuex'
import PocketBase from 'pocketbase';
import Notiflix from 'notiflix';

const API = 'https://ionds.app/pb';
const pb = new PocketBase(API);

pb.autoCancellation(false);


Notiflix.Notify.init({
	width: '300px',
	position: 'right-top',
	distance: '15px',
	opacity: 1,
	useFontAwesome: true,
    // timeout: 3000000,
	fontAwesomeIconSize: '20px',
	cssAnimationStyle: 'from-top',
	fontFamily: 'Source Sans Pro',
	failure: {
		background: '#FF6565',
		textColor: '#fff',
		notiflixIconColor: '#fff',
		fontAwesomeClassName: 'fas fa-trash-alt',
		fontAwesomeIconColor: '#fff',
	},
	warning: {
		background: '#ff793f',
		textColor: '#fff',
		notiflixIconColor: '#fff',
		fontAwesomeClassName: 'fas fa-exclamation-triangle',
		fontAwesomeIconColor: '#fff',
	},
	success: {
		background: '#009f7f',
		textColor: '#fff',
		notiflixIconColor: '#fff',
		fontAwesomeClassName: 'fas fa-check',
		fontAwesomeIconColor: '#fff',
	}
});

function removeFromLs(key) {
	localStorage.removeItem(key);
}

function createResourceStatuses() {
    return {
        users: { loading: false, loaded: false },
        projects: { loading: false, loaded: false },
        dataList: { loading: false, loaded: false },
        logs: { loading: false, loaded: false },
        helpContent: { loading: false, loaded: false }
    };
}

function resetResourceState(state) {
    state.resourceStatuses = createResourceStatuses();
    state.users = [];
    state.projects = [];
    state.sharedProjects = [];
    state.logs = [];
    state.general.help = '';
    state.dataList = [];
    state.dataFoldersList = [];
}

export default createStore({
    state: {
        isDarkMode: true,
        users: [],
        authStatuses: {
            isLoggedIn: false,
            loginInProcess: false,
            initialDataLoaded: false,
            errorMsg: ''
        },
        resourceStatuses: createResourceStatuses(),
        user: {},
        projects: [],
        sharedProjects: [],
        logs: [],
        general: {
            help: ''
        },
        dataList: [],
        dataFoldersList: []
    },
    getters: {
        isDarkMode(state) {
            return state.isDarkMode;
        },
        getUserInfo(state) {
            return function (uid) {
                return state.users.find(user => {
                    return user.uid == uid;
                })
            }
        },
        getProjectById(state) {
            return function (id) {
                return state.projects.find(project => {
                    return project.id == id;
                })
            }
        },
        getHelpContent(state) {
            return state.general.help.content;
        },
        getAllProjects(state) {
            return state.projects;
        },
        getPublicProjects(state) {
            return state.projects.filter(el => {
                return el.status == 'public';
            });
        },
        getUserProjects(state) {
            return state.projects.filter(el => {
                return (el.author === state.user.id);
            })
        },
        getResentlyProjects(state, getters) {
            let activity = [];
            let activityProjects = [];
            let counter = 0;
            for (let i = 0; i < state.user.activity.length; i++) {
                if (activity.indexOf(state.user.activity[i].projectId) == (-1)) {
                    let project = getters['getProjectById'](state.user.activity[i].projectId);
                    if (project) {
                        activity.push(state.user.activity[i].projectId);
                        activityProjects.push(project);
                        counter++;
                    }
                    if (counter >= 10) break;
                }
            }
            return activityProjects;
        },
        getSharedProjects(state) {
            return state.projects.filter(el => {
                return el.shared.indexOf(state.user.id) != (-1);
            });
        },
        getDataFoldersList(state) {
            return state.dataFoldersList;
        },
        getDataInfo(state) {
            return (id) => {
                return state.dataList.find(el => {
                    return el.id == id;
                })
            }
        },
        getAllDataList(state) {
            return state.dataList;
        },
        getDataList(state) {
            return (id) => {
                return state.dataList.filter(el => {
                    return el.category == id;
                });
            }
        },
        getUsers(state) {
            return state.users;
        },
        getLogs(state) {
            return state.logs.sort((a, b) => {
                if (a.id.slice(3) > b.id.slice(3)) return -1;
                if (a.id.slice(3) < b.id.slice(3)) return 1;
                return 0;
            });
        },
        getUser(state) {
            return state.user;
        },
        isLoggedIn(state) {
            return state.authStatuses.isLoggedIn;
        },
        getAuthStatuses(state) {
            return state.authStatuses;
        },
        getResourceStatuses(state) {
            return state.resourceStatuses;
        }
    },
    mutations: {
    },
    actions: {
        loginWithEmailAndPassword(context, params) {
            pb.collection('users').authWithPassword(params.email, params.password)
                .then(credential => {
                    context.state.authStatuses.loginInProcess = true;
                    if (credential.email) context.dispatch('login');
                })
                .catch((error) => {
                    context.state.authStatuses.errorMsg = error.message;
                    context.state.authStatuses.loginInProcess = false;
                    router.replace('/auth');
                    removeFromLs('pocketbase_auth');
                });
        },
        loginWithGoogle(context) {
            pb.collection('users').authWithOAuth2({ provider: 'google' })
                .then(credential => {
                    context.state.authStatuses.loginInProcess = true;
                    if (!credential.record.bio) {
                        context.dispatch('cteateUser', credential);
                    } else {
                        context.dispatch('login');
                    }
                })
                .catch((error) => {
                    context.state.authStatuses.errorMsg = error.message;
                    context.state.authStatuses.loginInProcess = false;
                    router.replace('/auth');
                    removeFromLs('pocketbase_auth');
                });
        },
        login(context) {
            context.state.authStatuses.loginInProcess = true;
            context.state.authStatuses.initialDataLoaded = false;
            resetResourceState(context.state);

            let credential = {};
            pb.collection('users').authRefresh()
                .then(responce => {
                    credential = responce;
                    
                    pb.collection('users').getOne(credential.record.id)
                        .then(responce => {
                            context.state.user = responce;
                            context.state.user.avatarUrl = pb.files.getUrl(context.state.user, context.state.user.avatar);
                            context.state.authStatuses.isLoggedIn = true;
                            context.state.authStatuses.initialDataLoaded = true;
                            context.state.authStatuses.loginInProcess = false;
                            if (router.currentRoute._value.name == 'auth') router.replace('/');
                        })
                        .catch((error) => {
                            context.state.authStatuses.errorMsg = error.message;
                            context.state.authStatuses.loginInProcess = false;
                            context.state.authStatuses.initialDataLoaded = false;
                            router.replace('/auth');
                            removeFromLs('pocketbase_auth');
                        }) 
                })
                .catch(err => {
                    context.state.authStatuses.loginInProcess = false;
                    context.state.authStatuses.initialDataLoaded = false;
                    router.replace('/auth');
                    removeFromLs('pocketbase_auth');

                    if (err.status == 403) {
                        context.state.authStatuses.errorMsg = 'Your account is blocked';
                        context.dispatch('showNotification', {
                            type: 'warning',
                            text: 'Your account is blocked'
                        });
                    } else {
                        context.state.authStatuses.errorMsg = err;
                    }
                })
        },
        cteateUser(context, userCred) {
            pb.collection('users').update(userCred.record.id, {
                uid: userCred.record.id,
                friends: [],
                emailVisibility: true,
                projects: {
                    personal: [],
                    shared: []
                },
                projectHistory: {},
                projectHistoryFile: '',
                activity: [],
                role: 'user',
                status: 'offline',
                bio: {
                    phone: '',
                    name: userCred.meta.name,
                    description: '',
                    university: ''
                }
            })
                .then(() => {
                    context.dispatch('login');
                })
        },
        logout(context) {
            pb.authStore.clear();
            context.state.authStatuses.isLoggedIn = false;
            context.state.authStatuses.initialDataLoaded = false;
            resetResourceState(context.state);
            router.replace('/auth');
        },
        showNotification(context, params) {
            Notiflix.Notify[params.type](params.text);
        },
        saveUserInfo(context, user) {
			return pb.collection('users').update(user.id, user);
		},
        saveHelpContent(context, content) {
			return pb.collection('general').update('kukyaofiwmtw7r8', {
                help: {
                    content: content
                }
            });
		},
        deleteProject(context, id) {
            return pb.collection('projects').delete(id);
        },
        deleteData(context, id) {
            return pb.collection('data').delete(id);
        },
        saveProject(context, action) {
			if (action.isNew) 
                return pb.collection('projects').create(action.project);
            else
                return pb.collection('projects').update(action.project.id, action.project);
		},
        saveData(context, action) {
            if (action.isNew) 
                return pb.collection('data').create(action.data);
            else 
                return pb.collection('data').update(action.data.id, action.data);
		},
        addLog(context, logData) {
            context.state.logs.sort((a, b) => {
                if (a.id.slice(3) > b.id.slice(3)) return 1;
                if (a.id.slice(3) < b.id.slice(3)) return -1;
                return 0;
            });
            context.state.logs.push(logData);
            return pb.collection('logs').create(logData);
        },
        updateLog(context, logData) {
            return pb.collection('logs').update(logData.id, logData);
        },
        fetchHelpContent(context) {
            context.state.resourceStatuses.helpContent.loading = true;

            return pb.collection('general').getOne('kukyaofiwmtw7r8')
                .then(responce => {
                    context.state.general.help = responce.help;
                    context.state.resourceStatuses.helpContent.loaded = true;
                })
                .finally(() => {
                    context.state.resourceStatuses.helpContent.loading = false;
                });
        },
        fetchProjects(context) {
            context.state.resourceStatuses.projects.loading = true;

            if (context.state.user.id) {
                return pb.collection('projects').getFullList({
                    filter: `
                                author = "${context.state.user.uid}" ||
                                status = "public" ||
                                shared ?~ "${context.state.user.uid}"
                            `
                })
                .then(responce => {
                    context.state.projects = responce;
                    context.state.resourceStatuses.projects.loaded = true;
                })
                .finally(() => {
                    context.state.resourceStatuses.projects.loading = false;
                });
            }
            context.state.resourceStatuses.projects.loaded = true;
            context.state.resourceStatuses.projects.loading = false;
            return Promise.resolve();
        },
        fetchUsers(context) {
            context.state.resourceStatuses.users.loading = true;

            return pb.collection('users').getFullList({
                sort: "-created"
            })
                .then(responce => {
                    context.state.users = responce;
                    for (let i = 0; i < context.state.users.length; i++) {
                        context.state.users[i].avatarUrl = pb.files.getUrl(context.state.users[i], context.state.users[i].avatar);
                    }
                    context.state.resourceStatuses.users.loaded = true;
                })
                .finally(() => {
                    context.state.resourceStatuses.users.loading = false;
                });
        },
        fetchLogs(context) {
            context.state.resourceStatuses.logs.loading = true;

            return pb.collection('logs').getList(1, 200, {
                sort: '-updated',
            })
                .then(responce => {
                    context.state.logs = responce.items;
                    context.state.resourceStatuses.logs.loaded = true;
                })
                .finally(() => {
                    context.state.resourceStatuses.logs.loading = false;
                });
        },
        fetchDataList(context) {
            context.state.resourceStatuses.dataList.loading = true;

            return pb.collection('data').getList(1, 200, {
                filter: `
                    authors ?~ "${context.state.user.id}" ||
                    isPublic = ${true}
                `
            })
                .then(responce => {
                    context.state.dataList = responce.items;
                    context.state.dataFoldersList = [];
                    
                    context.state.dataList.forEach(el => {
                        if (context.state.dataFoldersList.indexOf(el.category) == (-1)) {
                            context.state.dataFoldersList.push(el.category);
                        }
                    });
                    context.state.resourceStatuses.dataList.loaded = true;
                })
                .finally(() => {
                    context.state.resourceStatuses.dataList.loading = false;
                });
        },
        updateUserActivity(context, data) {
            let activityLength = 50;
            context.state.user.activity = (data.activity.length > activityLength) ? data.activity.slice(0, -1) : data.activity;
            if (context.state.user.activity.length > 50) {
                context.state.user.activity.splice(0, context.state.user.activity.length - activityLength);
            }
            return pb.collection('users').update(data.uid, {
                activity: context.state.user.activity
            });
        },
        updateUserProjectHistory(context, note) {
            let resultsLength = 12;

            if (!context.state.user.projectHistory[note.projectID]) context.state.user.projectHistory[note.projectID] = [];

            context.state.user.projectHistory[note.projectID].push({
                id: note.noteID,
                results: note.results,
                params: note.params
            });
            context.state.user.projectHistory[note.projectID].sort((a, b) => {
                if (a.id > b.id) return 1;
                if (a.id < b.id) return -1;
                return 0;
            });
            if (context.state.user.projectHistory[note.projectID].length > resultsLength) {
                context.state.user.projectHistory[note.projectID].splice(0, context.state.user.projectHistory[note.projectID].length - resultsLength);
            }

            return pb.collection('users').update(note.id, {
                projectHistory: context.state.user.projectHistory
            });
        },
        pullProjectHistory(context, param) {
            context.state.user.projectHistory = param.data;
            return pb.collection('users').update(param.user, {
                projectHistory: context.state.user.projectHistory
            });
        },
        addSharedUserToProject(context, params) {
            return pb.collection('projects').update(params.id, {
                shared: params.sharedUsers
            });
        },
        removeSharedUser(context, params) {
            return pb.collection('projects').update(params.id, {
                shared: params.sharedUsers
            });
        },
        deleteProjectResult(context, data) {
            let index = context.state.user.projectHistory[data.projectID].findIndex(el => el.id == data.id);
            context.state.user.projectHistory[data.projectID].splice(index, 1);
            if (context.state.user.projectHistory[data.projectID].length == 0) delete context.state.user.projectHistory[data.projectID];
            return pb.collection('users').update(data.uid, {
                projectHistory: context.state.user.projectHistory
            });
        },
        deleteAllProjectResults(context, data) {
            delete context.state.user.projectHistory[data.projectId];
            return pb.collection('users').update(data.uid, {
                projectHistory: context.state.user.projectHistory
            });
        },
        toggleTheme(context, theme) {
            context.state.isDarkMode = theme;
            localStorage.setItem('theme', (theme) ? 'dark' : 'light');
            if (theme)
                document.head.querySelector('meta[name="theme-color"]').setAttribute('content', '#14191f');
            else
                document.head.querySelector('meta[name="theme-color"]').setAttribute('content', '#f3f7f8');
        },
        downloadJsonAsFile(context, param) {
            const json = JSON.stringify(param.value);
            const blob = new Blob([json], { type: "application/json" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = param.name;
            document.body.appendChild(a)
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    },
    modules: {

    }
})
